<template>
  <div>
    <v-popover
      offset="8"
      trigger="hover"
      placement="bottom"
      popover-class="avatar--popover"
      style="margin-top: -2px;"
    >
      <div class="label--type-of-issue" :style="{ backgroundColor: color }">
        <component :is="icon" />
      </div>

      <p slot="popover" class="text-xs">
        {{ label }}
      </p>
    </v-popover>
  </div>
</template>

<script>
import Vue from 'vue';

import IconTypeTask from '@/components/icons/IconTypeTask.vue';
import IconTypeDefect from '@/components/icons/IconTypeDefect.vue';
import IconTypeQc from '@/components/icons/IconTypeQc.vue';

const TYPE_MAP = {
  TASK: {
    icon: IconTypeTask,
    color: '#0088FF',
    label: 'Task'
  },
  DEFECT: {
    icon: IconTypeDefect,
    color: '#FF5F57',
    label: 'Defect'
  },
  QC: {
    icon: IconTypeQc,
    color: '#FEBC2F',
    label: 'Quality Check (QC)'
  }
};

const DEFAULT_OPTION = TYPE_MAP.TASK;

export default Vue.extend({
  props: {
    type: { type: String, default: '' }
  },

  computed: {
    option() {
      return TYPE_MAP[this.type] || DEFAULT_OPTION;
    },
    color() {
      return this.option.color;
    },
    icon() {
      return this.option.icon;
    },
    label() {
      return this.option.label;
    }
  }
});
</script>

<style scoped>
.label--type-of-issue {
  @apply text-xs rounded-full px-2 leading-4 ml-2 flex items-center h-4;
}
</style>
